<script lang="ts">
	import { formatNumberWithSeparators } from "../../../../functions";

    class AreeSostaRiservate {
        postiAutoDipendenti: boolean;
        numeroPostiAutoDipendenti: number;
        postiAutoDipendentiNote: string;
        postiMotoDipendenti: boolean;
        numeroPostiMotoDipendenti: number;
        postiMotoDipendentiNote: string;
        postiBikeDipendenti: boolean;
        numeroPostiBikeDipendenti: number;
        postiBikeDipendentiNote: string;
        postiBikeTipologia: string;
        postiAutoCarPooling: boolean;
        numeroPostiAutoCarPooling: number;
        postiAutoCarPoolingNote: string;
        depositoMonopattini: boolean;
        depositoMonopattiniNote: string;
        bikeScooterChargingPoints: boolean;
        bikeScooterChargingPointsNote: string;

        constructor(init?: AreeSostaRiservate) {
            Object.assign(this, init);
        }
    }

    export let data: AreeSostaRiservate = new AreeSostaRiservate();

    const properties = [
        { name: "Posti auto", key: "postiAutoDipendenti", numberKey: "numeroPostiAutoDipendenti", noteKey: "postiAutoDipendentiNote", type: "number" },
        { name: "Posti moto", key: "postiMotoDipendenti", numberKey: "numeroPostiMotoDipendenti", noteKey: "postiMotoDipendentiNote", type: "number" },
        { name: "Posti bici", key: "postiBikeDipendenti", numberKey: "numeroPostiBikeDipendenti", noteKey: "postiBikeDipendentiNote", type: "number" },
        { name: "Tipologia posti bici", key: "postiBikeTipologia", noteKey: "", type: "string" },
        { name: "Posti auto car pooling", key: "postiAutoCarPooling", numberKey: "numeroPostiAutoCarPooling", noteKey: "postiAutoCarPoolingNote", type: "number"},
        { name: "Deposito monopattini", key: "depositoMonopattini", noteKey: "depositoMonopattiniNote", type: "boolean" },
        { name: "Presenza di punti di ricarica per bici e/o monopattini", key: "bikeScooterChargingPoints", noteKey: "bikeScooterChargingPointsNote", type: "boolean" }

    ];

    function isAnyFieldSet(): boolean {
        return properties.some((property) => data?.[property?.key] !== undefined);
    }
</script>

<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
            <th class="border border-black">Numero</th>
            <th class="border border-black">Note</th>
        </tr>
    </thead>
    <tbody>
        {#each properties as property}
            <tr>
                <td class="text-center border border-black">{property?.name}</td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {#if property?.type === "string"}
                        {data?.[property?.key] || '-'}
                    {:else}
                        {#if data?.[property?.key] !== undefined}
                            {data?.[property?.key] ? 'Si' : 'No'}
                        {:else}
                            -
                        {/if}                
                    {/if}
                </td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] && data?.[property?.numberKey] ? formatNumberWithSeparators(data?.[property?.numberKey]) : '-'}
                </td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.[property?.key] && data?.[property?.noteKey] ? data?.[property?.noteKey] : '-'}</td>
            </tr>
        {/each}
    </tbody>
</table>